declare namespace $ {

	type $mol_view__sub_bog_vmap_app_menu_item_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_vmap_app_menu_item_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_vmap_app_menu_item extends $mol_button_minor {
		Label( ): $mol_view
		Keys( ): $mol_view
		keys( ): string
		act( next?: any ): any
		done( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map